module.exports = __webpack_public_path__ + "img/camera-polaroid.4a3aacac.svg";